import { mapState as rootMapState } from 'pinia';
import { useUserStore } from '@/store'
import util from '@/common/util.js';
import signLog from '../../components/sign-log';

const SUBMIT_TYPE = {
    PAGE_CHANGE: 'pageChange',
    AJAX_SUBMIT: 'ajaxSubmit'
};

export default {
    i18next: {
        ns: 'md-hero'
    },
    props: [
        'searchGroupTabs',
        'searchGroupConfig',
        'nameType',
        'nameRequired',
        'phoneRequired',
        'agreementData',
        'searchButton'
    ],
    data: function() {
        return {
            activeIndex: 0,
            searchText: ''
        };
    },

    computed: {
        ...rootMapState(useUserStore, { user: store => store.user }),
        registerOptions() {
            return {
                languageTextFn: {
                    registerTitle: _ => this.$t('md-hero.sellWithUs'),
                    submitRegister: _ => this.$t('md-hero.submit'),
                    toast: _ => this.$t('md-hero.submittedSuccessfully')
                },
                registerSubTitle: '',
                role: '1',
                leadType: 'Sale',
                nameType: this.nameType,
                nameRequired: this.nameRequired,
                ignoreSellerPhone: !this.phoneRequired
            };
        }
    },

    methods: {
        changeTab(index) {
            this.activeIndex = index;
        },

        ajaxSubmit(submitUrl, params, needToast = true, callback) {
            this.axiosIns
                .post(submitUrl, params)
                .then(res => {
                    // Buried event 
                    if (submitUrl === '/api-site/sell/addHouseInfo') {
                        this.$EventBus.$emit('siteTrack', {
                            ...params,
                            trackType: 'addHouseInfo',
                            ele: this.$el
                        });
                    }
                    if (needToast) {
                        util.toast(
                            this.$t('md-hero.submittedSuccessfully'),
                            2000
                        );
                    }
                    if (util.isFunction(callback)) {
                        callback();
                    }
                })
                .catch(() => {
                    if (needToast) {
                        util.toast(this.$t('md-hero.submittedFailed'));
                    }
                });
        },

        onSubmitHandler(args, index, submitType, submitUrl) {
            if (submitType === SUBMIT_TYPE.AJAX_SUBMIT) {
                this.ajaxSubmit(submitUrl, args[0], true);
            } else if (submitType === SUBMIT_TYPE.PAGE_CHANGE) {
                if (this.submitDisabled) {
                    return; 
                }
                this.submitDisabled = true;
                setTimeout(() => {
                    this.submitDisabled = false;
                }, 500);
                this.$EventBus.$emit(
                    'change-url',
                    util.setQueryField(args[0], submitUrl),
                    submitUrl.replace('/', '')
                );
            }
        },

        submitAddress({ address, data, callback }, index, submitType, submitUrl) {
            const { inp, type } = data;
            const queryData = {
                address,
                type,
                inp
            };

            if (submitType === SUBMIT_TYPE.AJAX_SUBMIT) {
                if (!this.user) {
                    signLog.register(
                        Object.assign({}, this.registerOptions, {
                            registerData: { address },
                            onregister: (user, inquiry) => {
                                this.ajaxSubmit(
                                    submitUrl,
                                    {
                                        fullAddress: address,
                                        type: 0
                                    },
                                    !inquiry,
                                    callback
                                );
                                return false;
                            },
                            onsuccess: (data, inquiry) => {
                                if (inquiry) {
                                    util.toast(
                                        this.$t(
                                            'md-hero.submittedSuccessfully'
                                        ),
                                        2000
                                    );
                                    if (util.isFunction(callback)) {
                                        callback();
                                    }
                                }
                                return false;
                            }
                        }),
                        'simpleRegister'
                    );
                } else {
                    this.ajaxSubmit(
                        submitUrl,
                        {
                            fullAddress: address,
                            type: 0
                        },
                        true,
                        callback
                    );
                }
            } else if (submitType === SUBMIT_TYPE.PAGE_CHANGE) {
                if (this.evaluationSubmitDisabled) {
                    return; 
                }
                this.evaluationSubmitDisabled = true;
                setTimeout(() => {
                    this.evaluationSubmitDisabled = false;
                }, 500);
                this.$EventBus.$emit(
                    'change-url',
                    util.setQueryField(queryData, '/evaluation'),
                    this.$t('md-hero.evaluation')
                );
            }
        }
    }
};
